import React from 'react';
import { Heart, Clock, Wallet } from 'lucide-react';
export function DifferentiationSection() {
  return <section className="w-full py-20 px-4 bg-white" data-id="element-28">
      <div className="max-w-4xl mx-auto" data-id="element-29">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-brown mb-12" data-id="element-30">
          ¿Por qué esto es distinto a todo lo que probaste?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-31">
          <div className="text-center p-6 rounded-xl bg-cream/50 hover:bg-cream transition-colors duration-300" data-id="element-32">
            <div className="mx-auto w-12 h-12 bg-terracotta/10 rounded-full flex items-center justify-center mb-4" data-id="element-33">
              <Heart className="w-6 h-6 text-terracotta" data-id="element-34" />
            </div>
            <h3 className="text-xl font-heading font-bold text-brown mb-3" data-id="element-35">
              No es restrictivo
            </h3>
            <p className="text-brown-light font-body" data-id="element-36">
              No te voy a pedir que vivas a lechuga (de hecho, te voy a explicar
              por qué la lechuga hoy te hace mal).
            </p>
          </div>

          <div className="text-center p-6 rounded-xl bg-cream/50 hover:bg-cream transition-colors duration-300" data-id="element-37">
            <div className="mx-auto w-12 h-12 bg-sage/10 rounded-full flex items-center justify-center mb-4" data-id="element-38">
              <Clock className="w-6 h-6 text-sage" data-id="element-39" />
            </div>
            <h3 className="text-xl font-heading font-bold text-brown mb-3" data-id="element-40">
              Es real
            </h3>
            <p className="text-brown-light font-body" data-id="element-41">
              Está pensado para la mujer que trabaja, que cuida a la familia y
              que no tiene tiempo de cocinar cosas raras.
            </p>
          </div>

          <div className="text-center p-6 rounded-xl bg-cream/50 hover:bg-cream transition-colors duration-300" data-id="element-42">
            <div className="mx-auto w-12 h-12 bg-brown/10 rounded-full flex items-center justify-center mb-4" data-id="element-43">
              <Wallet className="w-6 h-6 text-brown" data-id="element-44" />
            </div>
            <h3 className="text-xl font-heading font-bold text-brown mb-3" data-id="element-45">
              Es económico
            </h3>
            <p className="text-brown-light font-body" data-id="element-46">
              No necesitás suplementos importados de 100 dólares. Usamos lo que
              encontrás en la góndola de tu barrio.
            </p>
          </div>
        </div>
      </div>
    </section>;
}